<template>
  <div class="d-inline-block">
    <span @click="openModal" class="contacts-viewer-button">
      <slot />
    </span>

    <component
      v-if="isModalOpen"
      v-model="isModalOpen"
      :teamFilterOff="teamFilterOff"
      :title="title"
      :filters="filters"
      :is="asyncModalComponent"
    />
  </div>
</template>

<script>
export default {
  name: 'ContactsViewerButton',
  props: {
    teamFilterOff: Boolean,
    filters: {},
    title: String,
    disabled: Boolean,
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    asyncModalComponent() {
      if (!this.isModalOpen) return null;
      return () => import('./ContactsViewerModal');
    },
  },
  methods: {
    openModal() {
      if (this.disabled) return;

      this.isModalOpen = true;
    },
  },
};
</script>

<style>
.contacts-viewer-button {
  cursor: pointer;
  color: var(--v-primary-base);
  font-weight: bold;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}
</style>
